export default "__VITE_ASSET__1d269b8b__"